<template>
  <v-flex xs12 sm12 md12 lg12>
    <v-card class="mx-auto" xs12>
      <v-card-text>
        <v-treeview :items="items"
                    :search="search"
                    :filter="filter"
                    :transition="shouldAnimate"
                    :open.sync="open"
                    class="small-text">
          <template v-slot:prepend="{ item }">
            <v-icon v-if="item.children"
                    v-text="`mdi-${item.id === 1 ? 'home-variant' : 'folder-network'}`"></v-icon>
          </template>
          <template v-slot:prepend="{ item }">
            <v-btn color="red" @click="skiniFile(l.Id)" v-for="l in item.Racuni" :key="l.link" small>
              <v-icon small class="white--text">mdi-file-pdf</v-icon>
              <span class="white--text"> {{l.BrojRacuna}} </span>
            </v-btn>
            <a ref="aDownload" href="#" target="_blank"></a>
          </template>


          <template v-slot:append="{ item }">

            <v-menu bottom v-if="item.MoodleEKolegijID"
                    origin="center center"
                    transition="scale-transition">
              <template v-slot:activator="{ on }">
                <v-btn color="blue" class="white--text" @click="goToMoodle(item)" small v-on="on">
                  <v-icon class="white--text">mdi-file-document</v-icon>
                  &nbsp;&nbsp;
                  <span class="white--text">e-učenje</span>
                </v-btn>
              </template>
            </v-menu>

          
            <a ref="aDownload" href="#" target="_blank"></a>
          </template>

        </v-treeview>
      </v-card-text>
    </v-card>

  </v-flex>
</template>



<script>
  import { mapState } from 'vuex';

  export default {
    name: 'MySeminars',
    props: {
      loading: {
        type: Function,
        default: () => {
          return false
        }
      },
      shouldAnimate: { type: Boolean, default: true }
    },
    data: () => ({
      items: [

      ],
      open: [1, 2],
      search: null,
      caseSensitive: false,
      moodleUrl: 'https://elearning.algebra.hr/course/view.php?id='
    }),
    computed: {
      ...mapState('app', ['currentUser']),
      filter() {
        return this.caseSensitive
          ? (item, search, textKey) => item[textKey].indexOf(search) > -1
          : undefined
      }
    },

    mounted() {
      this.ucitajSeminare()
    },

    methods: {
      async ucitajSeminare() {
        this.loading(true);
        var data = { Vrsta: 1 }
        var result = await this.$fetchDataPromise('/api/Education/GetMyEducation', data).catch(x => { this.loading(false); this.$displayError(x) });

        if (typeof result !== 'undefined' && result != null) {
          // Dodajem u svaki item varijable koje traži ova kontrola: name i children
          this.items = result.map(x => {
            var obj = x;
            obj.name = x.Ime;
            return obj;
          });
        }

        this.loading(false);
      },

      async skiniFile(RacunId) {

        this.loading(true);
        var data = { RacunId: RacunId }
        var result = await this.$fetchDataPromise('/api/Invoice/GetRacun', data).catch(x => { this.loading(false); this.$displayError(x) });

        if (result) {
          this.$downloadByteArray(result.EncodedFile, result.Extension, result.Name);
        }

        this.loading(false);


      },

      goToMoodle(item) {
        var moodleLink = this.moodleUrl + item.MoodleEKolegijID + '&jwt=' + this.currentUser.Token;
        window.open(moodleLink);
      }

    }
  }
</script>

<style>
  .small-text .v-treeview-node__label {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// VueSrc/Education/my_education_components/MySeminars.vue